"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSelectRandomEnum = exports.enumValues = exports.enumKeys = exports.enumMax = void 0;
const crypto_1 = require("crypto");
const number_1 = require("./number");
function enumMax(keys) {
    return (0, number_1.max)(enumValues(keys));
}
exports.enumMax = enumMax;
function enumKeys(keys) {
    return Object.keys(keys).filter((v) => isNaN(Number(v)));
}
exports.enumKeys = enumKeys;
function enumValues(values) {
    return Object.keys(values)
        .map(v => Number(v))
        .filter((v) => !isNaN(v))
        .sort();
}
exports.enumValues = enumValues;
function makeSelectRandomEnum(values) {
    const vals = enumValues(values);
    const len = vals.length;
    return () => vals[(0, crypto_1.randomInt)(len)];
}
exports.makeSelectRandomEnum = makeSelectRandomEnum;
//# sourceMappingURL=enum.js.map